import iconDigitalEnrollment from '@/assets/images/solutions/category-digital-enrollment.png'
import iconEduAdmin from '@/assets/images/solutions/category-edu-admin.png'
import iconOnlineAssessment from '@/assets/images/solutions/category-online-assessment.png'
import iconValueMall from '@/assets/images/solutions/category-value-mall.png'
import iconHomeSchool from '@/assets/images/solutions/category-home-school.png'
import iconFinance from '@/assets/images/solutions/category-finance.png'
import iconDataStats from '@/assets/images/solutions/category-data-stats.png'

import contentDigitalEnrollment from '@/assets/images/solutions/content-digital-enrollment.jpg'
import contentEduAdmin from '@/assets/images/solutions/content-edu-admin.jpg'
import contentOnlineAssessment from '@/assets/images/solutions/content-online-assessment.jpg'
import contentValueMall from '@/assets/images/solutions/content-value-mall.jpg'
import contentHomeSchool from '@/assets/images/solutions/content-home-school.jpg'
import contentFinance from '@/assets/images/solutions/content-finance.jpg'
import contentDataStats from '@/assets/images/solutions/content-data-stats.jpg'

import featureTraining from '@/assets/images/solutions/feature-training.png'
import featureQuestionBank from '@/assets/images/solutions/feature-question-bank.png'
import featurePractice from '@/assets/images/solutions/feature-practice.png'
import featurePaperGeneration from '@/assets/images/solutions/feature-paper-generation.png'
import featureExamGrading from '@/assets/images/solutions/feature-exam-grading.png'
import featurePrivateDeploy from '@/assets/images/solutions/feature-private-deploy.png'

import scenarioCenter from '@/assets/images/solutions/scenario-center.png'
import scenarioDashboard from '@/assets/images/solutions/scenario-dashboard.jpg'
import productIntroDashboard from '@/assets/images/solutions/product-intro-dashboard.jpg'
import moduleSystemBase from '@/assets/images/solutions/module-system-base.png'
import moduleCoreBusiness from '@/assets/images/solutions/module-core-business.jpg'
import moduleSpecialEducation from '@/assets/images/solutions/module-special-education.png'
import moduleDataDecision from '@/assets/images/solutions/module-data-decision.png'
import moduleValueExtension from '@/assets/images/solutions/module-value-extension.png'
import advantageQuantifiable from '@/assets/images/solutions/advantage-quantifiable.png'
import advantageIntelligent from '@/assets/images/solutions/advantage-intelligent.png'
import advantageFullScenario from '@/assets/images/solutions/advantage-full-scenario.png'
import advantageDataDriven from '@/assets/images/solutions/advantage-data-driven.png'
import platformValueMonitor from '@/assets/images/solutions/platform-value-monitor.png'
import platformValueVisualBg from '@/assets/images/solutions/platform-value-visual-bg.png'
import valueSchool from '@/assets/images/solutions/value-school.png'
import valueManager from '@/assets/images/solutions/value-manager.png'
import valueClassTeacher from '@/assets/images/solutions/value-class-teacher.png'
import valueTeacher from '@/assets/images/solutions/value-teacher.png'
import valueParent from '@/assets/images/solutions/value-parent.png'
import valueStudent from '@/assets/images/solutions/value-student.png'
import productCtaBg from '@/assets/images/solutions/product-cta-bg.png'
import productCtaGraphic from '@/assets/images/solutions/product-cta-graphic-alpha.png'
import scenarioEducationBureau from '@/assets/images/solutions/scenario-education-bureau.png'
import scenarioSingleSchool from '@/assets/images/solutions/scenario-single-school.png'
import scenarioDemoSchool from '@/assets/images/solutions/scenario-demo-school.png'
import scenarioEduGroup from '@/assets/images/solutions/scenario-edu-group.png'

export const solutionsBannerSlides = [
  {
    id: 1,
    title: '成熟产品定制',
    subtitle: '深耕行业数字化，提供成熟可靠的解决方案，支持按需定制与快速交付',
    bg: 'linear-gradient(135deg, #0066ff 0%, #003d99 50%, #001a66 100%)'
  },
  {
    id: 2,
    title: '教培行业数字化解决方案',
    subtitle: '覆盖招生、教务、测评、家校、财务、数据全链路',
    bg: 'linear-gradient(135deg, #0044cc 0%, #0066ff 50%, #3399ff 100%)'
  }
]

export const solutionCategories = [
  {
    id: 'digital-enrollment',
    title: '数字招生',
    icon: iconDigitalEnrollment,
    contentImage: contentDigitalEnrollment,
    summary: '多渠道招生获客、线索跟进、试听转化一体化，助力机构高效招生。'
  },
  {
    id: 'edu-admin',
    title: '教务管家',
    icon: iconEduAdmin,
    contentImage: contentEduAdmin,
    summary: '学员档案、智能排课、考勤签到、多校区统一管理，让教务运营更高效。'
  },
  {
    id: 'online-assessment',
    title: '在线测评',
    icon: iconOnlineAssessment,
    contentImage: contentOnlineAssessment,
    summary: '在线考试、刷题练习、智能组卷与成绩分析，满足多种测评场景。'
  },
  {
    id: 'value-mall',
    title: '增值商城',
    icon: iconValueMall,
    contentImage: contentValueMall,
    summary: '课程周边、学习资料、增值服务在线售卖，拓展机构营收渠道。'
  },
  {
    id: 'home-school',
    title: '家校服务',
    icon: iconHomeSchool,
    contentImage: contentHomeSchool,
    summary: '家校沟通、消息通知、成长反馈，构建高效透明的家校互动体系。'
  },
  {
    id: 'finance',
    title: '财务管家',
    icon: iconFinance,
    contentImage: contentFinance,
    summary: '收费管理、收支统计、对账报表，让机构财务清晰可控。'
  },
  {
    id: 'data-stats',
    title: '数据统计',
    icon: iconDataStats,
    contentImage: contentDataStats,
    summary: '多维度经营数据分析与可视化报表，辅助科学决策。'
  }
]

export const solutions = [
  {
    id: 'edu-management',
    title: '教培机构管理系统',
    icon: 'el-icon-reading',
    summary: '面向教培机构的综合管理系统，涵盖学员管理、课程排课、财务统计、家校沟通等核心功能，助力教培机构数字化运营。',
    features: [
      '学员档案与报名管理',
      '智能排课与考勤签到',
      '财务收支与报表统计',
      '家校互动与消息通知',
      '在线约课与试听管理',
      '多校区统一管理'
    ],
    tags: ['教培', '管理系统', 'SaaS']
  },
  {
    id: 'moral-education',
    title: '德育教务文档收集评比平台',
    icon: 'el-icon-document-checked',
    summary: '面向教育机构的德育教务文档在线收集、审核、评比一体化平台，支持多级评审和数据统计分析。',
    features: [
      '文档在线提交与分类管理',
      '多级审核与评比流程',
      '评分规则灵活配置',
      '评比结果公示与排名',
      '数据统计与报表导出',
      '移动端便捷操作'
    ],
    tags: ['德育平台', '文档管理', '教育']
  },
  {
    id: 'online-exam',
    title: '在线考试/刷题练习系统',
    icon: 'el-icon-edit',
    summary: '专业的在线考试与刷题练习平台，支持多种题型、智能组卷、防作弊监控和成绩分析，适用于各类考试培训场景。',
    features: [
      '多种题型支持（单选/多选/填空/简答）',
      '智能组卷与题库管理',
      '在线考试与限时控制',
      '防作弊与监考功能',
      '成绩统计与错题分析',
      '刷题练习与模拟考试'
    ],
    tags: ['在线考试', '刷题系统', '教育']
  },
  {
    id: 'ai-security',
    title: 'AI安防监控系统',
    icon: 'el-icon-video-camera',
    summary: '基于人工智能视觉分析的安防监控系统，支持人脸识别、行为分析、异常检测和实时告警，适用于多种安防场景。',
    features: [
      'AI视觉分析与目标检测',
      '人脸识别与访客管理',
      '异常行为智能告警',
      '多路视频接入与存储',
      '移动端远程监控',
      '数据统计与报表分析'
    ],
    tags: ['AI安防', '视频监控', '智能分析']
  }
]

export const otherSolutionsHint = '更多行业解决方案持续更新中，欢迎咨询定制...'

/** 顶部菜单二级项与解决方案页区块锚点映射 */
export const solutionSectionAnchors = {
  'edu-management': 'edu-management',
  'moral-education': 'moral-education',
  'online-exam': 'online-exam'
}

/** 导航菜单中不跳转的解决方案 */
export const disabledSolutionNavIds = ['ai-security']

export function getSolutionNavPath(solutionId) {
  const anchor = solutionSectionAnchors[solutionId]
  return anchor ? `/solutions#${anchor}` : `/solutions/${solutionId}`
}

export const applicationScenarios = {
  centerImage: scenarioCenter,
  dashboardImage: scenarioDashboard,
  items: [
    {
      id: 'employee-training',
      title: '员工培训',
      desc: '培训结束后立即组织考试，即时检验培训效果，巩固学习内容',
      position: 'top-left'
    },
    {
      id: 'recruitment-exam',
      title: '招聘考试',
      desc: '支持大规模远程笔试，自动阅卷打分，显著提升招聘筛选效率',
      position: 'top-right'
    },
    {
      id: 'questionnaire-competition',
      title: '问卷竞赛',
      desc: '以趣味问答形式收集反馈与意见，活跃团队氛围，沉淀有效数据',
      position: 'bottom-left'
    },
    {
      id: 'exam-assessment',
      title: '考试考核',
      desc: '适用于绩效考评、晋升考核等量化评价，线上全程跟踪确保公平公正',
      position: 'bottom-right'
    }
  ]
}

export const solutionProductIntro = {
  dashboardImage: productIntroDashboard,
  platformTitle: '智育德中小学智慧德育平台',
  highlights: [
    '面向教委、学校、年级等多级教育管理单位，一站式德育/教务资料线上收集、任务督办、文档归档、评优投票、数据统计一体化管理平台。 支持网页、安卓、iOS 多端使用。',
    '打通家校师生四维育人通道，推动德育工作数字化、量化、闭环化、精准化升级，助力构建新时代三全育人新格局。'
  ],
  stats: [
    { id: 'system', label: '1大系统底座' },
    { id: 'business', label: '5大核心业务' },
    { id: 'feature', label: '2大特色育人' },
    { id: 'decision', label: '1套数据决策' },
    { id: 'extension', label: 'N项增值拓展' }
  ]
}

export const solutionProductModules = {
  title: '产品核心功能模块',
  summary: '连接家校，赋能师生。集德育评价、心理护航、班级管理与数据决策于一体的智慧德育平台，助力构建全员、全过程、全方位的育人新格局。',
  items: [
    {
      id: 'system-base',
      title: '系统底座',
      subtitle: '稳固支撑全业务',
      icon: 'icon-xitongguanli',
      image: moduleSystemBase,
      intro: '作为平台核心运行基座，为所有德育业务提供安全、稳定、标准化支撑，适配单校、多校区、集团化、区域化部署。',
      features: [
        {
          title: '组织架构管理',
          desc: '灵活搭建学校、校区、学部、年级、班级架构，自动切换学年学期，适配各类办学模式。'
        },
        {
          title: '师生档案管理',
          desc: '对接学籍系统，支持师生信息批量导入、实时同步，适配转学、休学、毕业等人员异动管理。'
        },
        {
          title: '分级权限管理',
          desc: '适配校领导、德育主任、班主任、任课教师、心理教师、学生、家长多角色，实现菜单、操作、数据三级隔离。'
        },
        {
          title: '安全日志溯源',
          desc: '全操作、全积分变动留痕存档，支持数据备份恢复，合规保障校园数据安全。'
        }
      ]
    },
    {
      id: 'core-business',
      title: '核心业务',
      subtitle: '覆盖日常德育刚需',
      icon: 'icon-shixishengguanli',
      image: moduleCoreBusiness,
      intro: '覆盖中小学90%以上常规德育工作，实现德育工作数字化、流程化、台账化落地。',
      features: [
        {
          title: '德育积分与综合素质评价',
          desc: '智能量化评价，自动核算积分，无缝对接综合素质评价系统。'
        },
        {
          title: '学生奖惩全流程管理',
          desc: '在线审批闭环，自动关联成长档案，过程可追溯。'
        },
        {
          title: '全品类德育活动管理',
          desc: '活动线上开展，一键统计台账，过程留痕归档。'
        },
        {
          title: '班级德育量化考评',
          desc: '日常打分、自动排名、问题闭环管理，提升班级德育效能。'
        },
        {
          title: '家校协同共育体系',
          desc: '实时互动、信息互通，构建家校联动的共育机制。'
        }
      ]
    },
    {
      id: 'special-education',
      title: '特色育人',
      subtitle: '打造精准德育体系',
      icon: 'icon-zhishimenhu',
      image: moduleSpecialEducation,
      intro: '实现心理健康闭环管理与重点学生靶向帮扶，全过程跟踪记录，精准守护学生身心健康。',
      features: [
        {
          title: '学生心理健康管理',
          desc: '筛查、预警、干预、跟踪全闭环管理，建立学生心理档案，智能识别异常并持续守护身心健康。'
        },
        {
          title: '重点学生精准帮扶',
          desc: '智能标记重点学生，制定一对一帮扶方案，记录谈心、家校沟通与整改过程，动态评估帮扶成效。'
        }
      ]
    },
    {
      id: 'data-decision',
      title: '数据决策',
      subtitle: '赋能德育管理升级',
      icon: 'icon-fenxi',
      image: moduleDataDecision,
      intro: '大数据赋能德育，台账自动生成、数据可视可查，实现德育管理科学化、决策精准化。',
      features: [
        {
          title: '自动台账',
          desc: '自动生成全品类德育台账，支持一键编辑、导出与打印。'
        },
        {
          title: '多维统计与成果汇总',
          desc: '多维度统计德育指标，全局掌握全校德育动态；自动汇总学期成果，快速支撑德育工作总结。'
        }
      ]
    },
    {
      id: 'value-extension',
      title: '增值拓展',
      subtitle: '适配高阶特色需求',
      icon: 'icon-tuozhan',
      image: moduleValueExtension,
      intro: '高阶功能灵活选配，满足多类型办学主体个性化需求。可按需选配高阶功能，适配特色学校、寄宿制学校、教育集团、区域教育局等多元应用场景。',
      features: [
        { title: '校本特色德育体系定制', desc: '' },
        { title: 'AI学生品行趋势分析与风险预判', desc: '' },
        { title: '宿舍德育量化考评', desc: '' },
        { title: '教师德育工作量考核', desc: '' },
        { title: '多校集团化统筹管理', desc: '' },
        { title: '区域德育数据汇总督导', desc: '' }
      ]
    }
  ]
}

export const solutionCoreAdvantages = [
  {
    id: 'quantifiable',
    title: '量化德育，有据可评',
    subtitle: 'QUANTITATIVE MORAL EDUCATION',
    desc: '自定义德育评价体系，积分自动核算，打破传统思维，颠覆新的管理模式，让德育工作可视化、可量化、可追溯。',
    detailTitle: '自定义德育评价体系',
    detailSubtitle: '让德育评价更科学、更高效',
    detailDesc: '以积分自动核算代替传统凭印象、靠感觉的评价模式，让德育工作真正实现可视化、可量化、可追溯。',
    points: [
      { title: '自定义指标', desc: '灵活配置评价维度' },
      { title: '积分自动核算', desc: '规则引擎智能计算' },
      { title: '数据实时统计', desc: '多维度可视化分析' },
      { title: '可追溯可验证', desc: '记录可追溯，结果可验证' }
    ],
    icon: 'icon-ehr_x_deyukaoping',
    image: advantageQuantifiable
  },
  {
    id: 'intelligent',
    title: '智能平台，减负增效',
    subtitle: 'INTELLIGENT PLATFORM',
    desc: '全流程数据云端存储，拥有资料自动归档与统计分析，一键生成各类德育台账、报表、工作总结，大幅度减轻老师、德育部门的工作量。',
    detailTitle: '全流程数据云端存储',
    detailSubtitle: '让德育台账管理更轻松、更高效',
    detailDesc: '从资料创建到结果汇总全流程数字化，任务资料自动结构化归档，一键生成各类台账、报表与工作总结。',
    points: [
      { title: '云端存储', desc: '数据安全不丢失，随时随地可访问' },
      { title: '自动归档', desc: '任务资料结构化，归档有序管理' },
      { title: '一键生成', desc: '各类台账报表，工作总结一键出' },
      { title: '高效协作', desc: '降低统计工作量，提升协作效率' }
    ],
    icon: 'icon-AI_zhineng',
    image: advantageIntelligent
  },
  {
    id: 'full-scenario',
    title: '全场景覆盖，闭环育人',
    subtitle: 'FULL-SCENE COVERAGE',
    desc: '融合日常考评、活动育人、奖惩管理、心理育人、重点帮扶、家校协同，实现校园全场景，构建完整德育工作闭环，落实全员全过程育人要求。',
    detailTitle: '全场景德育管理',
    detailSubtitle: '构建完整德育工作闭环',
    detailDesc: '贯通校内外评价场景，多端数据实时同步，形成“数据采集—分析评估—精准干预—持续改进”的智慧闭环。',
    points: [
      { title: '全场景覆盖', desc: '6大核心场景，全方位管理' },
      { title: '闭环管理', desc: '完整工作闭环，提升工作效率' },
      { title: '数据驱动', desc: '科学决策，精准育人' },
      { title: '五育融合', desc: '全面发展，立德树人' }
    ],
    icon: 'icon-changjing',
    image: advantageFullScenario
  },
  {
    id: 'data-driven',
    title: '数据赋能，精准育人',
    subtitle: 'DATA EMPOWERMENT',
    desc: '可视化数据大屏，多维度学情分析，智能预警问题学生，先于预测发现问题，辅助育人，家校共育提供系统性数据支撑。',
    detailTitle: '数据驱动德育决策',
    detailSubtitle: '精准赋能育人实效',
    detailDesc: '以可视化数据大屏与多维学情分析，构建学生全景画像，为学校、教师、家长提供科学决策支撑。',
    points: [
      { title: '可视化数据大屏', desc: '全局数据一览无余，关键指标实时呈现' },
      { title: '多维度学情分析', desc: '多维数据动态分析，学情画像精准描绘' },
      { title: '智能预警机制', desc: '风险学生及时预警，问题隐患提前干预' },
      { title: '精准数据支撑', desc: '数据赋能科学决策，家校共育协同发力' }
    ],
    icon: 'icon-fenxi',
    image: advantageDataDriven
  }
]

export const solutionPlatformValue = {
  title: '平台价值',
  enTitle: 'Platform Value',
  visualBg: platformValueVisualBg,
  monitorImage: platformValueMonitor,
  items: [
    {
      id: 'school',
      title: '对学校',
      desc: '规范迎检，数智育人，品牌提升',
      detail:
        '规范德育管理体系，标准化德育工作流程，打造数字化德育特色亮点，轻松应对上级督导检查，提升学校育人品牌。',
      image: valueSchool
    },
    {
      id: 'manager',
      title: '对德育管理者',
      desc: '减负提效，数据治校',
      detail:
        '告别繁琐台账统计，全局掌握全校德育数据，一键生成各类德育报表，精准定位问题班级与学生，提升德育管理效率。',
      image: valueManager
    },
    {
      id: 'class-teacher',
      title: '对班主任',
      desc: '减负留痕，精准育人',
      detail:
        '简化班级德育管理工作，自动留存班级德育资料，便捷开展量化评价与家校沟通，让班级管理更轻松高效。',
      image: valueClassTeacher
    },
    {
      id: 'teacher',
      title: '对教师',
      desc: '便捷记录，协同育人',
      detail:
        '全员参与育人评价，便捷记录学生日常表现，及时反馈教育效果，让每位教师都成为德育工作的参与者。',
      image: valueTeacher
    },
    {
      id: 'parent',
      title: '对家长',
      desc: '实时知情，家校同育',
      detail:
        '实时了解孩子在校综合表现，主动参与家庭教育，家校协同共育，陪伴孩子健康成长。',
      image: valueParent
    },
    {
      id: 'student',
      title: '对学生',
      desc: '轨迹可循，健康成长',
      detail:
        '量化成长轨迹，正向激励良好品行，清晰看见自身进步，激发自我管理与持续向上的动力。',
      image: valueStudent
    }
  ]
}

export const solutionMoralScenarios = {
  title: '应用场景',
  enTitle: 'APPLICATION SCENARIOS',
  summary: '数字化赋能德育工作，分层适配各级教育主体，助力全过程育人',
  items: [
    {
      id: 'education-bureau',
      title: '教育局',
      desc: '适配区域德育统筹、数据统计、工作督导、成果汇总等管理需求。',
      theme: 'blue',
      image: scenarioEducationBureau
    },
    {
      id: 'single-school',
      title: '单所中小学',
      desc: '满足日常德育量化、班级管理、台账归档、家校共育常态化使用。',
      theme: 'cyan',
      image: scenarioSingleSchool
    },
    {
      id: 'demo-school',
      title: '特色示范学校',
      desc: '支持定制红色德育、劳动德育等特色育人体系，打造德育示范标杆。',
      theme: 'gold',
      image: scenarioDemoSchool
    },
    {
      id: 'edu-group',
      title: '教育集团/多校集群',
      desc: '实现多校统一德育标准、数据汇总、统一督导管理。',
      theme: 'purple',
      image: scenarioEduGroup
    }
  ]
}

export const solutionProductCta = {
  title: '专属部署、定制开发、上门培训、全程运维、迭代升级',
  subtitle: '分层适配多办学主体，打造标准化、特色化、数字化德育管理新范式',
  buttonText: '立即咨询',
  bgImage: productCtaBg,
  graphicImage: productCtaGraphic
}

export const solutionFeatures = [
  {
    id: 'training',
    title: '培训功能',
    desc: '录播视频在线观看',
    icon: featureTraining
  },
  {
    id: 'question-bank',
    title: '题库管理',
    desc: '多题型支持，批量导入',
    icon: featureQuestionBank
  },
  {
    id: 'practice',
    title: '刷题练习',
    desc: '支持电脑移动端，随时刷题\n数据统计纠错提分',
    icon: featurePractice
  },
  {
    id: 'paper-generation',
    title: '智能组卷',
    desc: '随机组卷，章节练习卷，自定义试卷',
    icon: featurePaperGeneration
  },
  {
    id: 'exam-grading',
    title: '考试阅卷',
    desc: '智能考试管理，自动阅卷，留档存阅',
    icon: featureExamGrading
  },
  {
    id: 'private-deploy',
    title: '私有部署',
    desc: '支持客户私有化部署，数据安全\n一次付费终身使用',
    icon: featurePrivateDeploy
  }
]
